import React, { Component } from 'react';
import { isEmpty } from "lodash";
import Spin from '../../../commonModules/interface/Spin.jsx';
import { CardLayout, BreadCrumb } from './containers/Layout';
import MapWithMarkers from  './../../../../global/mapReactLibrary/MapLeaflet.jsx';
import ListShop from './shops/ListShop.jsx';
import FormShop from './shops/FormShop.jsx';
import SingleShop from './shops/SingleShop.jsx';
import { Button, Card, Grid, Box } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin, InputSelectNative } from '../../../commonModules/interface/form-input-inline.jsx';
import SwipeableTabs from '../../../commonModules/MUI/SwipeableTabs';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import Dialog from '../../../commonModules/interface/Dialog.jsx';
import AccordionFilter from './Filter/AccordionFilter.jsx';
import { toast } from 'react-toastify';
import FormLoc from './localisations/FormLoc.jsx';

class Shops extends Component{
    state = {
        view: "list",

        tabIndex:1,
        
        breadcrumb:"",

        singleShop:{},
        single:{
            id: "",
            name: ""
        },

        lat: 0,
        long:0.0,
        storeGeoPosition: [],
       
        floats:[
            'latitude',
            'longitude'
        ],
        search:{
            searchPays: "",
            searchVille: "",

        },

        map:"",
        geocoder:"",

        shop:{
            id:"",
        },
        manager: "",
        managerDisplay: {},
        errors:{
            manager: ""
        }
    }
    componentDidMount = async () => {
        console.log("[INFO] MOUNTING SHOPS...");
        this.initMap();
        const { USERS } = this.props;
        if( isEmpty(USERS) ){
            await this.props.fetchUsers()
        }
    }
    normalizeStr = (str) => {// remove accent and lower case str
        str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
        return str
    }
    
    initMap =  async () =>{
        const { SHOPS } = this.props;
        console.log("Init Map")
        let lat = 0.0;
        let long = 0.0;
        var storeHouseGEOTmp = [];
        let nbItem = 0;

        if (SHOPS){
            console.log(SHOPS);
            Object.values(SHOPS).map( shop => {
                lat = lat + shop.latitude
                long = long + shop.longitude
                storeHouseGEOTmp.push({
                    boxId: shop.name,
                    longitude: shop.longitude,
                    latitude: shop.latitude,
                });
                nbItem ++;
            })
        }
        if (nbItem !== 0 ){
            this.setState({
                lat: lat/nbItem,
                long: long/nbItem,
                storeGeoPosition: storeHouseGEOTmp,
            })
        }
    }
    
    handleSingle = (shop) => {
        this.setState({
            breadcrumb: shop.name,
            singleShop:shop,
            view: "single"
        })
    }
    handleCreateLoc = (shop) => {
        this.setState({
            breadcrumb: shop.name,
            singleShop: shop,
            view: "locForm"
        })
    }
    handleUpdate = (shop) => {
        this.setState({
            breadcrumb: shop.name,
            singleShop:shop,
            view: "update"
        })
    }
    handleUpdateManager = (shop) => {
        this.setState({
            shop: shop,
            managerPopup: true
        })
    }
    countShopStocks = (shop) => { // nombre de produits en stock disponible dans le magasin
        const { AVAILABLE, PRODUCTS } = this.props
        if (!AVAILABLE || !PRODUCTS) return 0
        const productIds = new Set()
        Object.values(AVAILABLE).forEach(stock => {
            if (stock.shop_id === shop.id && stock.quantity > 0 && PRODUCTS[stock.product_id]) {
                productIds.add(stock.product_id)
            }
        })
        return productIds.size
    }
    handleEmptyShop = (shop) => {
        if (this.countShopStocks(shop) === 0) {
            toast.info(`Le magasin ${shop.name} n'a aucun article en stock`)
            return
        }
        this.setState({
            emptyShop: shop
        })
    }
    handleConfirmEmptyShop = () => {
        const { emptyShop } = this.state
        this.setState({ emptyShop: null })
        this.props.changePage("sales", true, emptyShop.id)
    }
    handleChange = (e) => { 
        const { name, value } = e.target
        
        this.setState({
            [name] : value
        })
    }
    handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        
        this.setState({
            [name]: value,
            [displayName]: option
        })
    }
    handleSubmitShopManager = async () => {
        let newShop = Object.assign({}, this.state.shop)        
        newShop.shop_manager = this.state.manager
        if (this.state.MDP !== "WelloWork"){
            toast.error("MOT DE PASSE INCORECT")
            return
        }

        console.log('====================================');
        console.log({newShop});
        console.log('====================================');
        try{
            await this.props.updateShop(newShop)

            if(this.props.STATE.shops.error){                    
                toast.error( this.props.STATE.shops.error.message)
            } else {
                toast.success( "Le manager a été mis à jour avec succes")
                this.handleClose()
            }
            
        } catch(err){
            console.log("[ERROR] SUBMIT UPDATE ", err);
            toast.error("Un Problème est survenu")
        }
    }
    handleSearch = async (e) => {
        const field = e.target.name
        const value = e.target.value
        this.setState({
            ...this.state,
            search:{
                ...this.state.search,
                [field]:e.target.value
            }
        })
    } 

    handleClose = () => {
        this.setState({
            view: "list",
            breadcrumb:"",
            managerPopup: false,
            shop: {},
            manager: "",
            managerDisplay: {}
        });
        
    }

    render(){
        console.log("[STATE]",this.state);
        // console.log("[PROPS]",this.props);
        const { view, breadcrumb, singleShop, managerPopup, shop, emptyShop } = this.state;
        const { STATE, SHOPS, USERS, isSuperAdmin } = this.props;

        return(
            <CardPage 
                title="Magasins" 
                storehouse
                action={view === "list" &&
                    <Button 
                        color="primary"
                        variant="contained"
                        onClick={ () => this.setState({ view: "new", breadcrumb: "Nouveau" }) }
                    >
                        Nouveau
                    </Button>
                }
            >
                <BreadCrumb breadcrumb={ breadcrumb } title="Magasins" back={this.handleClose} />                
                {STATE.shops.fetching && <Spin />}

                {view === "update" &&
                    <FormShop 
                        shop={singleShop}
                        update
                        {...this.props}
                        handleClose={this.handleClose}
                    />
                }
                {managerPopup && !isEmpty(shop) && isSuperAdmin &&
                    <Dialog 
                        disableBackdropClick
                        block={true}
                        close={() => this.setState({ managerPopup: false, shop: {} })}
                        title={`Modifier le responsable du magasin ${this.state.shop.name}`}
                        submitAction={this.handleSubmitShopManager}
                    >
                        <Box p={2}>
                            <InputSelectMagasin 
                                label="Responsable"
                                options={!isEmpty(USERS) && Object.values(USERS).map( user =>
                                    ({value: user.userID, label: user.email})
                                )}
                                value={this.state.managerDisplay}
                                onChange={ option => this.handleSelect(option, "manager")}
                                error={this.state.errors.manager}
                            />
                            <InputText
                                name="MDP" 
                                value={this.state.MDP} 
                                label="Mot de Passe" 
                                placeholder="Mot De Passe" 
                                required
                                error={!!this.state.errors.MDP} 
                                helperText={this.state.errors.MDP} 
                                onChange={this.handleChange}
                            />
                        </Box>
                    </Dialog>
                }
                
                {!isEmpty(emptyShop) &&
                    <Dialog 
                        block={true}
                        close={() => this.setState({ emptyShop: null })}
                        title={`Vider le magasin ${emptyShop.name}`}
                        submitAction={this.handleConfirmEmptyShop}
                        submitTitle="Continuer"
                    >
                        <Box p={2}>
                            Une nouvelle vente va être préparée avec les {this.countShopStocks(emptyShop)} produits
                            en stock dans ce magasin, pour la totalité de leurs quantités.
                            Les prix ne sont pas remplis : vous devrez les saisir avant de valider la vente.
                        </Box>
                    </Dialog>
                }

                {view === "new" && 
                    <FormShop 
                        {...this.props}
                        handleClose={this.handleClose}
                    /> 
                }
                
                {view === "single" &&
                    <SingleShop shop={singleShop} {...this.props} />
                }
                {view === "locForm" &&
                    <FormLoc 
                        handleClose={this.handleClose}
                        shop={this.state.singleShop}
                    />
                }
                {view === "list" && 
                    <SwipeableTabs
                        labels={["Liste", "Carte"]}
                        default="Liste"
                    >
                        <div>
                            <AccordionFilter>
                                {/* <Box p={2}>
                                    <h4 className="card-title">Recherche</h4>                                 */}
                                    <Grid container>
                                        <Grid item sm={6} xs={12}>
                                            <InputText type="text" id="searchPays" className="form-control" value={this.state.search.searchPays} onChange={this.handleSearch} name="searchPays" title="Pays"/>                                    
                                        </Grid>
                                        <Grid item sm={6} xs={12}>
                                            <InputText type="text" id="searchVille" className="form-control" value={this.state.search.searchVille} onChange={this.handleSearch} name="searchVille" title="Ville"/>
                                        </Grid>
                                    </Grid>
                                {/* </Box> */}
                            </AccordionFilter>
                            
                            
                            
                            {!isEmpty(SHOPS) && 
                                <ListShop 
                                    {...this.state}
                                    {...this.props}
                                    handleSingle={this.handleSingle}
                                    handleUpdate={this.handleUpdate}
                                    handleUpdateManager={this.handleUpdateManager}
                                    handleCreateLoc={this.handleCreateLoc}
                                    handleEmptyShop={this.handleEmptyShop}
                                />
                            }
                            {isEmpty(SHOPS) && 
                                <div className="text-center">
                                    <h5>Pas de Magasins</h5> 
                                    cliquez sur <Button 
                                        className="text-right btn btn-xs btn-warning"
                                        onClick={ ()=> this.setState({ view: "new" }) }
                                    >Nouveau</Button>  pour entrer un nouveau Magasin
                                </div>
                            }
                        </div>
                        
                        <Card 
                            style={{
                                width: '100%',
                                height: '550px'
                            }}
                        >
                            <MapWithMarkers lat={this.state.lat} lng={this.state.long} paygoMapList={this.state.storeGeoPosition}/>
                        </Card>   
                    </SwipeableTabs>
                }
            </CardPage>

        )
    }
}

export default Shops